<template lang="pug">
div.login.abs-fit
  div.login-header
    div.h1 {{ appName }}
    //- div.h4.mt2 安全、高效、节能。定制功能，满足多种应用场景。
  div.login-body
    div.register-box(@keypress.enter="register")
      div.login-box-header
        h3 注册新用户
      div.login-box-form
        a-form-model(:rules="rules" :model="model" ref="form")
          a-form-model-item(prop="username")
            a-input(size="large" placeholder="账号" v-model="model.username" autocomplete="off")
              a-icon(slot="prefix" type="user")
          a-form-model-item(prop="nickname")
            a-input(size="large" placeholder="姓名" v-model="model.nickname" autocomplete="off")
              a-icon(slot="prefix" type="user")
          a-form-model-item(prop="mobile")
            a-input(size="large" placeholder="手机号" v-model="model.mobile" autocomplete="off")
              a-icon(slot="prefix" type="mobile")
          a-form-model-item(prop="password")
            a-input(:type="model.password ? 'password' : 'text'" size="large" placeholder="密码" v-model="model.password" autoComplete="new-password")
              a-icon(slot="prefix" type="key")
          a-form-model-item(prop="rePassword")
            a-input(:type="model.rePassword ? 'password' : 'text'" placeholder="重复密码" v-model="model.rePassword" autoComplete="new-password")
              a-icon(slot="prefix" type="key")
      div.login-box-foolter
        a-button(type="primary" size="large" block @click="register" :loading="loading") 注 册
        app-link-btn.right.mt1(to="/login") 已有账号,直接登录
  div.login-footer    
    div.cneter
      span.p1 CopyRight2003-2020 深圳市农产品集团股份有限公司版权所有
    div.cneter.mt1
      span.p1 技术支持: 
        a(href="http://www.guhecloud.com/" target="_blank") 成都古河云科技有限公司 
      span.p1 推荐使用: 
        a.p1(href="https://www.google.cn/intl/zh-CN/chrome/" target="_blank") 谷歌浏览器
</template>

<script>
import { registerUser } from '@/services/AccountService';
export default {
  data() {
    return {
      appName: window.config.appName,
      rules: {
        username: [
          { required: true, message: '请填写账号' },
          {
            required: true,
            trigger: 'blur',
            message: '至少4位英文，不超过13位',
            pattern: /^[a-z0-9]{4,13}$/,
          },
        ],
        nickname: [{ required: true, message: '请填写姓名' }],
        mobile: [
          { required: true, message: '请填写手机号' },
          {
            required: true,
            trigger: 'blur',
            message: '手机号校验未通过',
            pattern: /^[1][3,4,5,6,7,8,9][0-9]{9}$/,
          },
        ],
        password: [
          { required: true, message: '请填写密码' },
          {
            required: true,
            trigger: 'blur',
            message: '支持数字和英文组合，至少6位，不超过18位',
            pattern: /^[a-z0-9]{6,18}$/,
          },
        ],
        rePassword: [
          { required: true, message: '请确认密码' },
          {
            required: true,
            message: '两次密码不一致。',
            trigger: 'blur',
            validator: (rule, value, callback, source, options) => {
              if (value === this.model.password) {
                callback();
              } else {
                callback('两次密码不一致。');
              }
            },
          },
        ],
      },
      model: {
        username: null,
        nickname: null,
        mobile: null,
        password: null,
        rePassword: null,
      },
      loading: false,
    };
  },
  methods: {
    async register() {
      const isValid = await this.$refs.form.validate();
      if (isValid) {
        const model = { ...this.model };
        try {
          this.loading = true;
          await registerUser(model); // /users/register
          this.$message.success('注册成功!');
          this.handleRegisterSuccess();
        } catch (error) {
          if (error.response.status === 401) {
            const errorMessage = error.response?.data?.error_description;
            this.$message.error(errorMessage || '用户名或手机号已存在。');
          }
        } finally {
          this.loading = false;
        }
      }
    },
    handleRegisterSuccess() {
      this.$router.push({ path: '/login' });
    },
  },
};
</script>

<style lang="less" scoped>
.login {
  display: flex;
  flex-direction: column;
  &-header {
    text-align: center;
    margin-top: 15vh;
    color: rgba(0, 0, 0, 0.85);
    flex: none;
  }

  &-body {
    flex: auto;
    .register-box {
      margin: auto;
      margin-top: 4em;
      width: 20em;
      @media screen and (max-width: 600px) {
        width: 90%;
      }
    }
  }

  &-footer {
    flex: none;
    margin: 2em auto;
    text-align: center;
  }
}
</style>
